export default "__VITE_ASSET__Dh$1o_IF__"